import { ApiUrl } from "../components/Common/ApiUrl";
import httpServiceInstance from "../helper/HttpService";

export const dashBoardReportService = async (data) => {
  const response = await httpServiceInstance.get(
    ApiUrl.DASHBOARD_REPORTS +
    `?noOfDays=${data?.noOfDays}&currentDate=${data?.currentDate}&tz=${data?.tz}`
  );
  return response;
};


export const dashBoardReportRegisteredUserService = async (data) => {
  const response = await httpServiceInstance.get(
    ApiUrl.DASHBOARD_REGISTERED_USERS_REPORT +
    `?noOfDays=${data?.noOfDays}&currentDate=${data?.currentDate}&tz=${data?.tz}`
  );
  return response;
};


export const dashBoardReportWorkoutService = async (data) => {
  const response = await httpServiceInstance.get(
    ApiUrl.DASHBOARD_TOTAL_WORKOUT_SESSIONS_REPORT +
    `?noOfDays=${data?.noOfDays}&currentDate=${data?.currentDate}&tz=${data?.tz}`
  );
  return response;
};

